var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    staticClass: "search-icon",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "currentColor",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.7 14.4099L12 10.6335C12.8 9.54037 13.4 8.14907 13.4 6.65838C13.4 2.98137 10.4 0 6.7 0C3 0 0 2.98137 0 6.65838C0 10.3354 3 13.3168 6.7 13.3168C8.2 13.3168 9.6 12.8199 10.7 11.9255L14.5 15.7019C14.7 15.9006 14.9 16 15.1 16C15.3 16 15.6 15.9006 15.7 15.7019C16.1 15.3043 16.1 14.7081 15.7 14.4099ZM6.7 11.4286C4 11.4286 1.8 9.24224 1.8 6.55901C1.8 3.97516 4 1.78882 6.7 1.78882C9.4 1.78882 11.6 3.97515 11.6 6.65838C11.5 9.24224 9.3 11.4286 6.7 11.4286Z",
      "fill": "currentColor"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }